import { useTranslation } from 'react-i18next'
import { BarChartData } from '../VideoScoreChart/components/BarChart/BarChart'
import styles from './VideoScoreBarChart.module.less'
import cls from 'classnames'
// import { useEffect } from 'react'

interface Props {
  overallDatas: BarChartData[]
  periodDatas: BarChartData[]
  defaultHeight?: number
  barWidth?: number
  barTextSize?: number
  barTextLineHeight?: string
  barLabelSize?: number
  overallFlex?: number
  periodFlex?: number
  chartGap?: number
}

function VideoScoreBarChart(props: Props) {
  const DEFAULT_HEIGHT = props.defaultHeight || 300
  const BAR_WIDTH = props.barWidth || 32
  const BAR_TEXT_SIZE = props.barTextSize || 18
  const BAR_TEXT_LINE_HEIGHT = props.barTextLineHeight || '29px'
  const BAR_LABEL_SIZE = props.barLabelSize || 14
  // delta 是让整体高度不会直接填满整个容器
  const DELTA = 0.85
  const maxOverallScore = [...props.overallDatas].sort((a, b) => b.score - a.score)[0].score
  const maxOverallMeanScore = [...props.overallDatas].sort((a, b) => b.meanScore - a.meanScore)[0]
    .meanScore
  const maxPeriodScore = [...props.periodDatas].sort((a, b) => b.score - a.score)[0].score
  const maxPeriodMeanScore = [...props.periodDatas].sort((a, b) => b.meanScore - a.meanScore)[0]
    .meanScore
  const score = Math.max(maxOverallScore, maxOverallMeanScore, maxPeriodMeanScore, maxPeriodScore)
  const ratio = (DEFAULT_HEIGHT / score) * DELTA

  return (
    <div
      className={styles.videoScoreBarChart}
      style={{ height: DEFAULT_HEIGHT, columnGap: props.chartGap || 100 }}
    >
      <div className={styles.videoScoreBarChartOverall} style={{ flex: props.overallFlex || 1 }}>
        {props.overallDatas
          .filter((data) => data.score > 0)
          .map((data, index) => {
            return (
              <div
                key={data.name + index}
                className={cls(styles.videoScoreBarChartItem, styles.overall)}
              >
                <div
                  className={cls(styles.videoScoreBarChartItemBar, styles.overall)}
                  style={{ height: data.score * ratio, background: '#8B77FB', width: BAR_WIDTH }}
                >
                  <span
                    className={styles.videoScoreBarChartItemMean}
                    style={{
                      bottom: data.meanScore * ratio,
                      width: BAR_WIDTH + 0.4 * BAR_WIDTH,
                    }}
                  ></span>
                  <span
                    className={styles.videoScoreBarChartItemScore}
                    style={{ fontSize: BAR_TEXT_SIZE, lineHeight: BAR_TEXT_LINE_HEIGHT }}
                  >
                    {data.score}
                  </span>
                </div>
                <MeanBlockTooltip
                  {...data}
                  color={'#8B77FB'}
                  className={styles.tooltip}
                  style={{ bottom: data.score * ratio * 0.5 }}
                />
                <span
                  className={styles.videoScoreBarChartItemText}
                  style={{
                    fontSize: BAR_LABEL_SIZE,
                  }}
                >
                  {data.name}
                </span>
              </div>
            )
          })}
      </div>
      <div className={styles.videoScoreBarChartPeriod} style={{ flex: props.periodFlex || 2 }}>
        {props.periodDatas
          .filter((data) => data.score > 0)
          .map((data, index) => {
            return (
              <div
                key={data.name + index}
                className={cls(styles.videoScoreBarChartItem, styles.period)}
              >
                <div
                  className={cls(styles.videoScoreBarChartItemBar, styles.period)}
                  style={{ height: data.score * ratio, background: '#63B0F9', width: BAR_WIDTH }}
                >
                  <span
                    className={styles.videoScoreBarChartItemMean}
                    style={{
                      bottom: data.meanScore * ratio,
                      width: BAR_WIDTH + 0.4 * BAR_WIDTH,
                    }}
                  ></span>
                  <span
                    className={styles.videoScoreBarChartItemScore}
                    style={{ fontSize: BAR_TEXT_SIZE, lineHeight: BAR_TEXT_LINE_HEIGHT }}
                  >
                    {data.score}
                  </span>
                </div>
                <MeanBlockTooltip
                  {...data}
                  color={'#63B0F9'}
                  className={styles.tooltip}
                  style={{ bottom: data.score * ratio * 0.5 }}
                />
                <span
                  className={styles.videoScoreBarChartItemText}
                  style={{ fontSize: BAR_LABEL_SIZE }}
                >
                  {data.name}
                </span>
              </div>
            )
          })}
      </div>
    </div>
  )
}

function MeanBlockTooltip(
  props: BarChartData & { color: string; className?: string; style?: React.CSSProperties }
) {
  const { t } = useTranslation()
  return (
    <div className={cls(styles.meanBlockTooltip, props.className)} style={props.style}>
      <div className={styles.block}>
        <span className={styles.scoreBlock} style={{ backgroundColor: props.color }}></span>
        <span>
          {props.name}: {props.score}
        </span>
      </div>
      <div className={styles.block}>
        <span className={styles.meanScoreBlock}></span>
        <span>
          {t('dashboard.projectDetailPage.videoView.norm')}: {props.meanScore}
        </span>
      </div>
    </div>
  )
}

export default VideoScoreBarChart
